import { RequestType } from '@/form/form.types';
import { IUsersCosmetologist, IUsersCosmetologistItem, UsersCosmetologistResponseType } from './UserCosmetologist.types';

export class UserCosmetologist implements IUsersCosmetologist {
    total: number;
    data: Array<IUsersCosmetologistItem> = [];

    constructor(data: UsersCosmetologistResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}